import React, { PureComponent } from 'react'
import { Panel, Row } from 'react-bootstrap'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import { compareObjects } from '../../../util/utils'

class StockComponent extends PureComponent {
  constructor () {
    super()
    this.state = {
      fieldsConfiguration: {
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  componentDidMount () {
    this.initializePermisions(this.props)
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.dossier && this.props.dossier.dossierId && !compareObjects(prevProps.componentConfiguration || {}, this.props.componentConfiguration, true)) {
      this.initializePermisions(this.props)
    }

    return prevProps
  }

  componentDidUpdate () {
  }

  render () {
    const {
      t, summaryOpen,
      actions: { togglePanel }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.SERVICE_DOSSIER.'
    return (
      <div className="sales-panel dossier-panel">
        <div className="header-panel" onClick={togglePanel}>
          <div className="name-wrapper">
            <i className="ico-sales" />
            <h4>{t(`${tKey}SERVICE_COMPONENT.TITLE`)}</h4>
          </div>
          <i className={summaryOpen ? 'ico-arrow-black-up' : 'ico-arrow-black-down'} />
        </div>
        <Panel expanded={summaryOpen} onToggle={() => {}} >
          <Panel.Collapse>
            <Row>
            </Row>
          </Panel.Collapse>
        </Panel>
      </div>
    )
  }
}

export default StockComponent
